import { TabContext, TabList, TabPanel } from '@mui/lab'
import {
    Badge,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    Tab,
    Typography,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { dataColumn, timeColumn } from '../../../components/DataColumn'
import table from '../../../helpers/table'
import { CheckCircle, HighlightOffOutlined } from '@mui/icons-material'
import { useGetVendorRFQListQuery, usePostVendorRfqChangeStatusMutation } from '../../../store/api/vendorApi'
import { useDispatch, useSelector } from 'react-redux'
import { updateVendorRfqData } from '../../../store/slice/mainToCardSlice'
import { DataGrid } from '@mui/x-data-grid'
import { GridToolbar } from '../../../components/GridToolbar/GridToolbar'
import { showSuccessToast, showWarningToast } from '../../../constToast/constToast'
import { useNavigate } from 'react-router-dom'
import { updateRFQMainIdSlice, updateVendorCodeReference } from '../../../store/slice/bidsSlice'
import { useGetButtonQuery } from '../../../store/api/buttonApi'
import { useTranslation } from 'react-i18next'
import { red } from '@mui/material/colors'

function VendorRFQ({ vendorCode }) {
    const value = '1'

    const { data: rfqListData, isLoading, error, refetch } = useGetVendorRFQListQuery(vendorCode)

    const [postChangeStatus] = usePostVendorRfqChangeStatusMutation()

    const dynamicKey = 'lineNo'

    const dispatch = useDispatch()

    const [tableData, setTableData] = useState([])
    useEffect(() => {
        if (!isLoading) {
            setTableData(rfqListData?.data)
        }
    }, [isLoading, rfqListData, error])

    useEffect(() => {
        if (error) {
            setTableData([])
        }
    }, [isLoading, rfqListData, error])

    const gridSize = useSelector((state) => state.dataGridSlice.size)
    const [pageSize, setPageSize] = React.useState(25)

    const [open, setOpen] = React.useState(false)

    const handleClickOpen = (id) => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
    }

    const [stateRfqId, setStateRfqId] = useState(0)
    const [stateBidId, setStateBidId] = useState(0)
    const [stateStatus, setStateStatus] = useState('')
    const [statusParams, setStatusParams] = useState(0)

    const handleUpdateData = (data) => {
        dispatch(updateVendorRfqData(data))
        setStateRfqId(data[0].rfqMainId)
        setStateBidId(data[0].bidMainId)
        setStateStatus(data[0].participationStatus)
    }

    const vendorRfqData = useSelector((state) => state.mainToCard.vendorRfqData)

    const navigate = useNavigate()

    const { data: buttonData } = useGetButtonQuery()
    const readAccess = buttonData?.data?.find((x) => x.menuId === 5004)?.readAccess

    const handleDoubleClick = () => {
        // if (stateStatus === 'Issued') return;

        dispatch(updateRFQMainIdSlice(stateRfqId))
        dispatch(updateVendorCodeReference(vendorCode))
        // if (stateStatus == 'Rejected') {
        //     showWarningToast(t('rfqRejected'))
        //     return;
        // } else if (readAccess) {
        //     navigate(`/bids/${stateBidId}?fromVendor`)
        // } else {
        //     navigate(`/not-access`)
        // }

        if (readAccess) {
            navigate(`/bids/${stateBidId}?fromVendor`)
        } else {
            navigate(`/not-access`)
        }
    }

    const { t } = useTranslation('rfq')
    // Columns
    const columns = [
        {
            field: 'actions',
            headerName: t('actions'),
            headerAlign: 'center',
            align: 'center',
            width: 70,
            renderCell: (params) => {
                const today = dayjs();
                const isDeadlinePassed = dayjs(params.row.rfqDeadline).isBefore(today);
                const participationStatus = params.row.participationStatus;

                let badgeContent = 'finished';
                let badgeColor = 'error';

                if (
                    participationStatus === 'Submitted' ||
                    participationStatus === 'Rejected' ||
                    isDeadlinePassed
                ) {
                    badgeContent = 'finished';
                    badgeColor = 'error';
                } else if (participationStatus === 'Issued') {
                    badgeContent = 'new';
                    badgeColor = 'primary';
                } else if (
                    participationStatus === 'In Process' ||
                    participationStatus === 'Accepted'
                ) {
                    badgeContent = 'open';
                    badgeColor = 'success';
                }

                return (
                    <Badge
                        badgeContent={badgeContent}
                        color={badgeColor}
                        size="small"
                        anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
                    />
                );
            }
        },
        dataColumn('rfqMainId', 'RFQ ID', 70),
        dataColumn('lineNo', t('lineNo'), 90),
        dataColumn('rfqNo', 'RFQ No', 150),
        dataColumn('rfqStatus', 'Status', 150),
        dataColumn('participationStatus', t('participationStatus'), 150),
        dataColumn('businessCategoryName', t('businessCategory'), 150),
        dataColumn('rfqType', t('rfqType'), 150),
        timeColumn('rfqDate', t('rfqDate'), 150),
        timeColumn('rfqDeadline', t('rfqDeadline'), 150),
        timeColumn('respondedDate', t('submittedDate'), 150),
        timeColumn('desiredDeliveryDate', t('expecteddeliveryDate'), 150),
        timeColumn('createdDate', t('rfqCreatedDate'), 150),
        dataColumn('emergency', t('rfqPriority'), 150),
        dataColumn('enteredBy', t('bidEnteredBy'), 150),
    ]

    const [visibleColumns, setVisibleColumns] = useState(table.generateVisibleFields(columns, 'vendorRFQ'))

    useEffect(() => {
        localStorage.setItem('vendorRFQ', JSON.stringify(visibleColumns))
    }, [visibleColumns])

    const rfqMainIdSlice = useSelector((state) => state.bidsSlice.rfqMainIdSlice)

    const dayjs = require('dayjs')
    const today = dayjs(new Date())

    const getRowClassName = (params) => {
        if (params.row.rfqMainId === rfqMainIdSlice) {
            return 'row-rfqIdColor'
        } else if (dayjs(params.row.rfqDeadline).isBefore(today)) {
            return 'row-disableColor'
        }
        return ''
    }


    const message = t(
        statusParams === 1 ? "confirmation.accept" : "confirmation.reject",

    );

    const refreshClicked = useSelector((state) => state.buttonSlice.refreshClicked)
    useEffect(() => {
        refetch()
        setTableData(rfqListData?.data)
    }, [refreshClicked])

    return (
        <>
            <DataGrid
                rows={tableData || []}
                columns={columns}
                onSelectionModelChange={(newSelection) => {
                    handleUpdateData(tableData.filter((row) => newSelection.includes(row[dynamicKey])))
                }}
                components={{
                    Toolbar: () => (
                        <GridToolbar
                            hiddenContent={true}
                            handleAddRow={true}
                            hiddenSearch={false}
                            hiddenRefresh={true}
                            handleReset={true}
                        />
                    ),
                }}
                density={gridSize}
                rowHeight={45}
                onRowDoubleClick={handleDoubleClick}
                loading={isLoading}
                getRowId={(row) => row[dynamicKey]}
                pageSize={pageSize}
                onPageSizeChange={(newPage) => setPageSize(newPage)}
                pagination
                showCellRightBorder
                getRowClassName={getRowClassName}
                columnVisibilityModel={visibleColumns}
                onColumnVisibilityModelChange={(newModel) => setVisibleColumns(newModel)}
            />

            <div>
                <Dialog open={open} onClose={handleClose} fullWidth>
                    <DialogTitle>{t('changeStatus')}</DialogTitle>
                    <Divider />
                    <DialogContent>
                        <DialogContentText>
                            <Typography component="span">
                                <strong>{message} {vendorRfqData?.[0]?.rfqNo}?</strong>
                            </Typography>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="contained"
                            onClick={() => {
                                postChangeStatus({
                                    rfqMainId: stateRfqId,
                                    status: statusParams,
                                    vendorCode: vendorCode,
                                })
                                handleClose()
                                showSuccessToast('Succesfully')
                            }}
                        >
                            {statusParams == 1 ? t('accept') : t('reject')}
                        </Button>
                        <Button variant="outlined" onClick={handleClose} sx={{ color: 'gray', borderColor: '#D3D3D3' }}>
                            {t('cancel')}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </>
    )
}

export default VendorRFQ
